function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#EDEEF0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.694 5.40002C12.9115 5.40002 13.097 5.48242 13.2505 5.64721C13.4168 5.79932 13.5 5.98312 13.5 6.19862V11.0662C13.5 11.2944 13.4168 11.4909 13.2505 11.6557C13.097 11.8078 12.9115 11.8838 12.694 11.8838H9.81557L10.6407 13.1007V13.5H7.35928V13.1007L8.18443 11.8838H5.32516C5.09488 11.8838 4.89659 11.8078 4.73028 11.6557C4.57676 11.4909 4.5 11.2944 4.5 11.0662V6.19862C4.5 5.98312 4.57676 5.79932 4.73028 5.64721C4.89659 5.48242 5.09488 5.40002 5.32516 5.40002H12.694ZM12.694 10.2676V6.19862H5.32516V10.2676H12.694Z",
  fill: "#43455C"
});

function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.197f5433.svg";
export { ForwardRef as ReactComponent };